import { useState, useEffect, PropsWithChildren } from 'react'

import useIntersect from '@src/quince-site-common/src/hooks/useIntersect'

export const CustomSectionLazyLoader: React.FC<PropsWithChildren<{ slug: string; isPageCache: boolean }>> = ({
  slug,
  children,
  isPageCache,
}) => {
  const [sectionRef, isSectionVisible] = useIntersect(null, '0px', 0, false)
  const [shouldRender, setShouldRender] = useState(false)

  useEffect(() => {
    if (isSectionVisible) setShouldRender(true)
  }, [isSectionVisible])

  useEffect(() => {
    if (shouldRender) {
      setShouldRender(false)
    }
  }, [slug])

  if (isPageCache) return children

  return <div ref={sectionRef}>{shouldRender && children}</div>
}
